// Shared configuration for Select components inside modals
// Fixes z-index issues and maintains consistent styling

export const modalSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    border: '1px solid #000',
    borderRadius: '4px',
    boxShadow: 'none',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px',
    overflowY: 'auto',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#000' : state.isFocused ? '#000' : 'white',
    color: state.isSelected ? '#fff' : state.isFocused ? '#fff' : '#333',
    '&:hover': {
      backgroundColor: '#000',
      color: '#fff',
    },
  }),
};

export const modalSelectProps = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed' as const,
  menuPlacement: 'auto' as const,
  maxMenuHeight: 200,
};